import { authHeader } from '../_helpers';

import axios_nomura from './axios-nomura.services';
import { userService } from './user.service';

import '../_configs';

var config = global.gConfig;

let handleResponse = userService.handleResponse;

const getMenus = async () => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return await fetch(`${config.webUrl}/ifund2/api/menu/get_all`, requestOptions).then(handleResponse);
};

export const generalService = {
  getMenus
};


export const fetchColors = async (type) => {
  return await axios_nomura.get(`api/v1/colors`, { params: { type: type } });
}